<template>
    <v-container>
        <v-text-field v-show="isSearchVisible"
                      v-model="tableFilter.searchText"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      class="mb-3"
                      hide-details></v-text-field>


        <div class="above-scroller" v-on:scroll="onTableScroll">
            <div class="scroller" :style="{ 'width' : tableWidth }"></div>
        </div>

        <v-data-table :headers="headerValues"
                      :items="data"
                      must-sort
                      fixed-header
                      :sort-by.sync="tableFilter.orderBy"
                      :sort-desc.sync="tableFilter.sortDesc"
                      :server-items-length="tableFilter.totalItems"
                      :loading="isLoading"
                      :items-per-page.sync="tableFilter.pageSize"
                      :page.sync="tableFilter.pageNo"
                      :footer-props="{'items-per-page-options': [25, 50, 100, 100, 1000]}"
                      item-class="d-flex justify-start"
                      class="elevation-1">

            <template v-slot:top>
                <div class="d-flex justify-end pa-4 pb-6">
                    <v-btn color="primary" @click="onExportData"><v-icon>mdi-file</v-icon>Export to Csv</v-btn>
                </div>
            </template>


            <template v-slot:item.incidentId="{ item }">
                <v-btn color="primary"
                       plain
                       class="ma-0 pa-0"
                       @click="onNavigateHighSevDetails(item.incidentId)">
                    {{ item.incidentId }}
                </v-btn>
                <div v-if="item.incidentSeverity">
                    <v-chip x-small @click="onClickSeverity(item.incidentSeverity)" class="mb-3">
                        {{ item.incidentSeverity }}
                    </v-chip>
                </div>
            </template>

            <template v-slot:item.affectedOperator="{ item }">
                <v-chip class="ma-1" :key="operator" small v-for="operator in onGetAffectedOperatorArray(item.affectedOperator)" @click="onClickOperatorName(operator)">
                    {{ operator }}
                </v-chip>
            </template>

            <template v-slot:item.pbiId="{ item }">
                <v-btn color="primary"
                       plain
                       class="ma-0 pa-0"
                       @click="onClickPbiId(item.pbiId)">
                    {{ item.pbiId }}
                </v-btn>

            </template>

            <template v-slot:item.statushubNotificationHistory="{ item }">
                <div v-html="item.statushubNotificationHistory"></div>
            </template>

            <template v-slot:item.incidentStartDate="{ item }">
                {{ item.incidentStartDate | DateTime }}
            </template>

            <template v-slot:item.incidentEndDate="{ item }">
                {{ item.incidentEndDate | DateTime }}
            </template>

            <template v-slot:item.pbiSubmitDate="{ item }">
                {{ item.pbiSubmitDate | DateTime }}
            </template>

            <template v-slot:item.incidentHandledDate="{ item }">
                {{ item.incidentHandledDate | DateTime }}
            </template>

            <template v-slot:item.incidentImage="{ item }">
                <v-dialog v-if="item.incidentImage">
                    <template v-slot:activator="{ on, attrs }">

                        <img style="max-width:300px;" :src="item.incidentImage" v-bind="attrs" :alt="item.incidentId"
                             v-on="on" />
                    </template>

                    <v-card>
                        <v-card-text>
                            <img style="width:100%;" :src="item.incidentImage" :alt="item.incidentId" />
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </template>

        </v-data-table>
    </v-container>
</template>

<script>
    import exportHelper from '../../helpers/exportCsvHelper.js';
    export default {
        name: 'TableChart',
        props: {
            heightV: {
                default: () => 500,
                type: Number
            },
            headers: {
                default: () => [],
                type: Array
            },
            data: {
                default: () => [],
                type: Array
            },
            tableFilter: {
                default() {
                    return {
                        searchText: "",
                        pageNo: 1,
                        pageSize: 100,
                        orderBy: "incidentStartDate",
                        sortDesc: true,
                        totalItems: 0
                    }
                },
                type: Object
            },
            isLoading: {
                default: false,
                type: Boolean
            },
            isSearchVisible: {
                default: true,
                type: Boolean
            },
        },
        watch: {
            deep: true,
            immediate: true,
            headers: {
                handler() {
                    this.onHandleHeadersChange()
                },
                deep: true,
                immediate: true,
            },
        },
        data: function () {
            return {
                searchText: "",
                loading: false,
                tableWidthNumber: 0,
                excludeHeaders: []
            }
        },
        created() {
            window.addEventListener("resize", this.setTableWidth);
        },
        mounted() {

        },
        computed: {
            tableWidth() {
                return `${this.tableWidthNumber}px`;
            },
            headerValues() {
                if (this.excludeHeaders) {
                    return this.headers.filter(header => !this.excludeHeaders.includes(header));
                }
                return this.headers;
            }
        },
        methods: {
            onTableScroll() {
                let scroller = document.querySelector('.above-scroller');
                let table = document.querySelector('.v-data-table__wrapper');
                table.scrollTo(scroller.scrollLeft, 0);
            },
            onNavigateHighSevDetails(incidentId) {
                let routeData = this.$router.resolve({ name: 'HighSevDetails', params: { id: incidentId } });
                window.open(routeData.href, '_blank');
            },
            onHandleHeadersChange() {

                if (this.headers && this.headers.length > 0) {
                    //lets check on headers that we can group to try save some precious space.

                    //check 1 incident id and severity this can be displayed below each other
                    if (this.headers.some(header => header.value === "incidentId") && this.headers.some(header => header.value === "incidentSeverity")) {
                        //remove incident severity as it will be grouped with incident id
                        this.excludeHeaders = this.headers.filter(header => header.value === "incidentSeverity");
                    }
                }

                this.setTableWidth();

            },
            onGetAffectedOperatorArray(affectedOperator) {
                if (!affectedOperator) return [];
                return affectedOperator.replace(/[\[\]\"]/g, "").split(',').filter(operator => operator !== ""); //eslint-disable-line
            },
            onClickOperatorName(operator) {
                this.$emit("on-operator-select", operator);
            },
            onClickSeverity(severity) {
                this.$emit("on-severity-select", severity);
            },
            setTableWidth() {
                var self = this;
                setTimeout(() => {
                    var table = document.querySelector('.v-data-table');
                    var tableRow = document.querySelector('.v-data-table tr:first-child');

                    if (table && tableRow) {
                        if (table.offsetWidth < tableRow.offsetWidth) {
                            self.tableWidthNumber = tableRow.offsetWidth;
                        }
                    }
                }, 200);
            },
            getItemData(value) {

                if (value?.includes("data:image")) {
                    let image = new Image();

                    image.src = value;

                    return image
                }

                return value ? value : "";
            },
            onExportData() {
                if (this.data) {

                    let exportResults = [];

                    this.data.forEach(item => {

                        let tempExportItem = {};

                        this.headers.forEach(keyHeader => {
                            Object.keys(item).forEach(keyItem => {
                                if (keyHeader.value === keyItem) {
                                    tempExportItem[keyHeader.text] = item[keyItem];
                                }
                            });
                        });

                        exportResults.push(tempExportItem);
                    });

                    exportHelper.exportCSVFile(this.headers.map(item => item.text), exportResults, "InocDataExport");
                }
            },
            onClickPbiId(pbiId) {
                window.open(`http://assist.mgsops.net/arsys/forms/remedyapp/PBM:Problem%20Investigation/Derivco/?qual=%271000000232%27=%22${pbiId}%22&cacheid=36161f98`)
            }
        }
    }
</script>
